import { render, staticRenderFns } from "./OceanEngineAccountDirectory.vue?vue&type=template&id=2788e5a4&scoped=true&"
import script from "./OceanEngineAccountDirectory.vue?vue&type=script&lang=js&"
export * from "./OceanEngineAccountDirectory.vue?vue&type=script&lang=js&"
import style0 from "./OceanEngineAccountDirectory.vue?vue&type=style&index=0&id=2788e5a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2788e5a4",
  null
  
)

export default component.exports